import { createSelector } from 'reselect';
import { selectSearchTerm, selectItemUpdates } from '../../../selectors';
import _ from 'lodash';
import search from '../../../reducers/search';

const selectNewInstallationGroup = (state) => state.newInstallationGroup;

const selectPendingInstallationGroups = (state) => state.newInstallationGroup.newInstallationGroups;

export { selectSearchTerm };

export const getPendingInstallationGroups = createSelector(
  [selectPendingInstallationGroups],
  (installationGroups) => {
    return installationGroups;
  }
);

export const getFilteredPendingInstallationGroups = createSelector(
  [selectPendingInstallationGroups, selectSearchTerm],
  (installationGroups, term) => {
    let _term = _.trim(term.toLowerCase());
    if(_term.length > 0) {
      return installationGroups.filter(f => f.name.toLowerCase().includes(_term));
    }
    return installationGroups;
  }
)
